import React from 'react';
import '../styles/Copyright.css';

function Copyright() {
    return (
        <div className='div-copyright'>
            <span className='span-copyright'>Copyright © <a className='a-copyright' href='https://www.centronacionaldeconsultoria.com/'>Centro Nacional de Consultoría (CNC)</a> {new Date().getFullYear()}</span>
        </div>
    );
}

export default Copyright;